// Reviews — mobile scroll progress bar (mirrors the UGC gallery's).
// The cards are a plain overflow-x carousel on mobile; we reflect scroll position into the
// green progress bar beneath. Desktop (grid, no overflow) has scrollWidth == clientWidth so
// the bar stays put and is display:none anyway.
(() => {
  const carousels = [...document.querySelectorAll('[data-rv-scroll]')];
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const wrap = carousel.closest('.rv__wrap');
    const fill = wrap && wrap.querySelector('.rv__progress-fill');
    if (!fill) return;

    let raf = null;
    const update = () => {
      raf = null;
      const max = carousel.scrollWidth - carousel.clientWidth;
      if (max <= 0) return;
      const ratio = Math.min(1, Math.max(0, carousel.scrollLeft / max));
      const pct = 40 + ratio * 60; // rests at 40%, fills to 100% at the end
      fill.style.width = pct.toFixed(1) + '%';
    };
    const onScroll = () => {
      if (raf == null) raf = requestAnimationFrame(update);
    };

    carousel.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });
})();
